import gql from 'graphql-tag';

export default {
    ROOM_QUERY: gql`
        query Room($roomId: String, $roomName: String) {
            room(roomId: $roomId, roomName: $roomName) {
                id,
                posterUrl,
                friendlyName,
                roomConfigurations {
                    id,
                    name,
                    value,
                    roomId,
                },
                meetingReasons {
                    id,
                    shortName,
                    description,
                    theo,
                    roomId,
                },
                advisorOptions {
                    id,
                    name,
                }
            }
        }`,
};



// WEBPACK FOOTER //
// ./src/graphql-operations/rooms.graphql.js